import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { loginRedirectAction } from '../../actions/LoginActions';
import { BIParceiroVendedorActions, BIParceiroListActions } from '../../actions/BIParceiroActions';
import { Button, Checkbox, Dropdown, Icon, Table } from 'semantic-ui-react';
import styled from 'styled-components';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

const StyledDropdown = styled(Dropdown)`
  &&& {
    div{
        font-size:10px !important;
        width: 100% !important;
    }
    span{
        font-size:10px !important;
        width:80px !important;
    }
    
}`;

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: -10px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableHeader = styled(Table.Header)`
  &&& th {
    padding: 10px !important;
    white-space: nowrap; /* impede quebra de linha */
  }
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
}

`;
const StyledTableRow = styled(Table.Row)`
  &&& {
    &:nth-child(even) {
      background-color: #f7f7f7;
    }

    &:nth-child(odd) {
      background-color: #ffffff;
    }
  }
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
`;

function Export(props) {
    const { BIParceiroVendedorActions, BIParceiroListActions } = props;
    const { userid, vendedorlist, vendedorlistloading, list, listloading } = props;

    const [vendedorDropdown, setVendedorDropdown] = useState();
    const [vendedorDropdownText, setVendedorDropdownText] = useState();
    const [todosVendedores, setTodosVendedores] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);

    let colunas = []

    if (list.length > 0) {
        colunas = Object.keys(list[0])
    }

    useEffect(() => {
        console.log('userid ->', userid);
        BIParceiroVendedorActions(userid);


    }, []);

    useEffect(() => {

        if (!isDownloading) return;

        if (list && list.length > 0) {
            if (isDownloading === true) {
                console.log('entrou aqui useeffect')
                exportToExcel();
            }
        } else {
            if (isExporting === false) {
                toast.error(
                    <div>
                        <p style={{ margin: 0 }}>Não há dados para exportar.</p>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );
            }
        }

        setIsDownloading(false);

    }, [list]);


    const handleDownload = async () => {
        if (todosVendedores || (userid && vendedorDropdown)) {

            try {

                setIsDownloading(true);


                if (todosVendedores === true) {
                    await BIParceiroListActions(userid, null);
                } else {
                    await BIParceiroListActions(userid, vendedorDropdown);
                }

            } catch (error) {

                setIsDownloading(false);

                toast.error(
                    <div>
                        <p style={{ margin: 0 }}>Erro ao exportar dados para o vendedor selecionado.</p>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );

                console.log(error);
            }

        } else {

            toast.error(
                <div>
                    <p style={{ margin: 0 }}>Selecione um vendedor para exportar os dados.</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        }
    };

    const handleGerarDados = async () => {
        if (todosVendedores || (userid && vendedorDropdown)) {

            try {

                // setIsDownloading(true);
                setIsExporting(true)


                if (todosVendedores === true) {
                    await BIParceiroListActions(userid, null);
                } else {
                    await BIParceiroListActions(userid, vendedorDropdown);
                }

                toast.success(
                    <div>
                        <p style={{ margin: 0 }}>Dados gerados com sucesso!</p>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );
                // setIsExporting(false)

            } catch (error) {

                // setIsDownloading(false);
                setIsExporting(false)


                toast.error(
                    <div>
                        <p style={{ margin: 0 }}>Erro ao gerar dados para o vendedor selecionado.</p>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );

                console.log(error);
            }

        } else {

            toast.error(
                <div>
                    <p style={{ margin: 0 }}>Selecione um vendedor para gerar os dados.</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        }
    }




    const exportToExcel = () => {

        const camposData = [
            'dtultcontato',
            'dtultcompra',
            'dtultorcamento',
            'd_piso',
            'd_bookpiso',
            'd_madeira',
            'd_bookripadorodape',
            'd_lastras',
            'd_banhos',
            'd_deck',
            'd_rodape',
            'd_wallripadoint',
            'd_forrovinilico'
        ];

        // Cria a estrutura dos dados com base nas colunas dinâmicas
        const formattedData = list.map((item) => {
            const row = {};
            colunas.forEach((coluna) => {
                if (camposData.includes(coluna) && item[coluna]) {
                    row[coluna] = moment(item[coluna]).format("DD/MM/YYYY HH:mm");
                } else {
                    row[coluna] = item[coluna];
                }
            });
            return row;
        });

        // Cria a planilha e o workbook
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Fechamento');

        // Exporta o arquivo
        XLSX.writeFile(workbook, `BI - Parceiros - ${vendedorDropdown ? vendedorDropdownText : 'Todos os vendedores'}  .xlsx`);

        toast.success(
            <div>
                <p style={{ margin: 0 }}>Arquivo baixado com sucesso!</p>
                <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
            </div>,
            {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                draggable: true,
                progress: undefined,
                style: {
                    background: "#fff",
                    color: "#000",
                },
            }
        );

    };

    return (
        <div>
            <ToastContainer className='foo' />
            {/* <h1>Exportar</h1> */}
            <p>Aqui você pode exportar a planilha de dados dos Parceiros para análise e compartilhamento.</p>
            <div style={{ display: 'flex', width: '70%', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <span style={{ marginRight: '10px' }}>Escolha um vendedor:</span>
                    <StyledDropdown
                        options={vendedorlist.map(item => ({
                            key: item.codvend,
                            text: item.vendedor,
                            value: item.codvendedor,
                        }))}
                        search
                        selection
                        scrolling
                        placeholder="Escolha um vendedor"
                        loading={vendedorlistloading === true}
                        value={todosVendedores ? '' : vendedorDropdown}
                        disabled={todosVendedores === true}
                        onChange={(e, { value }) => {
                            setVendedorDropdown(value);

                            const selectedOption = vendedorlist.find(
                                item => item.codvendedor === value
                            );

                            const selectedText = selectedOption?.vendedor || '';

                            setVendedorDropdownText(selectedText);
                        }}
                    />

                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

                    <Checkbox onChange={() => { setTodosVendedores(!todosVendedores), setVendedorDropdown(null) }} label='Todos os vendedores' />
                </div>
                <Button onClick={handleGerarDados} loading={listloading && isExporting && isDownloading === false} color='blue'>Gerar dados<Icon style={{ marginLeft: '5px' }} name="sync" /></Button>
                <Button onClick={handleDownload} loading={listloading && isDownloading} color='green'>Download<Icon style={{ marginLeft: '5px' }} name="download" /></Button>
            </div>
            {isExporting && (
                <div style={{ marginTop: '30px' }}>
                    <TableContainer>
                        <StyledTable id={'concirepasselog'} compact='very' size='small' loading={true}>
                            <StyledTableHeader>
                                <Table.Row>
                                    {colunas.map(item => (
                                        <Table.HeaderCell textAlign='center' width="1">{item}</Table.HeaderCell>
                                    ))}


                                </Table.Row>
                            </StyledTableHeader>

                            <StyledTableBody>

                                {list.map((item, index) => (
                                    <StyledTableRow key={index}>

                                        <Table.Cell textAlign='center'>{item.supervisor}</Table.Cell>
                                        <Table.Cell>{item.vendedor}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.codvend}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.codparc}</Table.Cell>
                                        <Table.Cell>{item.parceiro}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.classifica}</Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.dtultcontato ? moment(item.dtultcontato).format("DD/MM/YYYY") : '-'}
                                        </Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.dtultcompra ? moment(item.dtultcompra).format("DD/MM/YYYY") : '-'}
                                        </Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.dtultorcamento ? moment(item.dtultorcamento).format("DD/MM/YYYY") : '-'}
                                        </Table.Cell>

                                        <Table.Cell textAlign='center'>{item.d_piso ? moment(item.d_piso).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_bookpiso ? moment(item.d_bookpiso).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_madeira ? moment(item.d_madeira).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_bookripadorodape ? moment(item.d_bookripadorodape).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_lastras ? moment(item.d_lastras).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_banhos ? moment(item.d_banhos).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_deck ? moment(item.d_deck).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_rodape ? moment(item.d_rodape).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_wallripadoint ? moment(item.d_wallripadoint).format("DD/MM/YYYY") : '-'}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.d_forrovinilico ? moment(item.d_forrovinilico).format("DD/MM/YYYY") : '-'}</Table.Cell>

                                        <Table.Cell textAlign='center'>{item.leadpisos ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leadrodapes ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leaddecks ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leaddrywall ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leadwall ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leadbanhos ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leadforros ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leadferramentas ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>{item.leaddivisorias ?? 0}</Table.Cell>

                                        <Table.Cell textAlign='center'>{item.qtddevolucoescli ?? 0}</Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.montantedevolvidocli
                                                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.montantedevolvidocli)
                                                : 'R$ 0,00'}
                                        </Table.Cell>

                                        <Table.Cell textAlign='center'>{item.qtddevolucoesven ?? 0}</Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.montantedevolvidoven
                                                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.montantedevolvidoven)
                                                : 'R$ 0,00'}
                                        </Table.Cell>

                                        <Table.Cell textAlign='center'>{item.qtddevolucoeslog ?? 0}</Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.montantedevolvidolog
                                                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.montantedevolvidolog)
                                                : 'R$ 0,00'}
                                        </Table.Cell>

                                        <Table.Cell textAlign='center'>{item.qtddevolucoesout ?? 0}</Table.Cell>

                                        <Table.Cell textAlign='center'>
                                            {item.montantedevolvidoout
                                                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.montantedevolvidoout)
                                                : 'R$ 0,00'}
                                        </Table.Cell>
                                        <Table.Cell textAlign='center'>
                                            {item.montantecomprado12meses
                                                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.montantecomprado12meses)
                                                : 'R$ 0,00'}
                                        </Table.Cell>
                                        <Table.Cell textAlign='center'>{item.qtdecompras12meses ?? 0}</Table.Cell>
                                        <Table.Cell textAlign='center'>
                                            {item.montantecomprado4anos
                                                ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.montantecomprado4anos)
                                                : 'R$ 0,00'}
                                        </Table.Cell>
                                        <Table.Cell textAlign='center'>{item.qtdecompras4anos ?? 0}</Table.Cell>

                                    </StyledTableRow>
                                ))}



                            </StyledTableBody>
                        </StyledTable>
                    </TableContainer>
                </div>
            )}

        </div>
    )
}

const mapStateToProps = (state) => ({
    userid: state.LoginReducer.userid,
    vendedorlist: state.BIParceiroReducer.vendedorlist,
    vendedorlistloading: state.BIParceiroReducer.vendedorlistloading,
    list: state.BIParceiroReducer.list,
    listloading: state.BIParceiroReducer.listloading
})


export default withRouter(connect(mapStateToProps, {
    loginRedirectAction,
    BIParceiroVendedorActions,
    BIParceiroListActions
}
)(Export));
